import React from 'react';
import classNames from 'classnames';
import { object, string, shape } from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import AddressStatic from '@active/react-address-editor/components/AddressStatic';

const AgencyFeild = ({ value, className }) => (value ? <div className={classNames('agency-item', className)}>{value}</div> : '');

AgencyFeild.propTypes = {
  value: string,
};

const AgencyInfo = ({ agency }) => {
  if (Object.keys(agency).length === 0) {
    return null;
  }
  const { name, contactPerson: { email, address = {}, phoneNumber: { phone, extension } = {} } = {} } = agency;

  return (
    <div className="payment-agency-info">
      <div className="payment-agency-info-title" >
        <Locale id="checkout.lib.components.paymentResult.detail.agencyInfo.title" />
      </div>
      <div className="payment-agency-info-content" >
        <AgencyFeild value={name}/>
        <div className="agency-info-content__address">
          <AddressStatic address={address} />
        </div>
        {
          phone
          && <div className="agency-info-content__tel">
            <div className="agency-info-content__tel-title">
              <Locale id="checkout.lib.components.paymentResult.detail.agencyInfo.tel.title" />
            </div>
            <AgencyFeild value={phone}/>
            {
              extension && <span> - </span>
            }
            <AgencyFeild value={extension}/>
          </div>
        }
        {
          email
          && <div className="agency-info-content__email">
            <div className="agency-info-content__email-title">
              <Locale id="checkout.lib.components.paymentResult.detail.agencyInfo.email.title" />
            </div>
            <AgencyFeild value={email} />
          </div>
        }
      </div>
    </div>
  );
};

AgencyInfo.propTypes = {
  agency: shape({
    name: string,
    contactPerson: shape({
      email: string,
      address: object,
      phoneNumber: object,
    }),
  }),
};

AgencyInfo.defaultProps = {
  agency: {},
};

export default AgencyInfo;
